export default __webpack_public_path__ + "alberta-return-arrow.a5ca83b90d04573642b7.svg";